export const ICON_MAPPINGS = {
  well: "/images/map/marker_well_{0}.png",
  block: "/images/map/marker_block_station_{0}.png",
  bps: "/images/map/marker_bps_{0}.png",
  gms: "/images/map/marker_gms_{0}.png",
  pump: "/images/map/marker_pump_{0}.png",
  TTMSingleStation: "/images/map/marker_well_{0}.png",
  TTMGroupStation: "/images/map/marker_block_station_{0}.png",
  TTMProductionWell: "/images/map/marker_well_{0}.png",
  TTMInjectionWell: "/images/map/marker_well_{0}.png",
  TTMPhasePump: "/images/map/marker_pump_{0}.png",
  TTMInjectionStation: "/images/map/marker_well_{0}.png",
  TTMBlockStation: "/images/map/marker_block_station_{0}.png",
  TTMBlock: "/images/map/marker_block_station_{0}.png",
  TTMLongStrokePumpDriver: "/images/map/marker_bps_{0}.png",
  TTMVacuum: "/images/map/marker_pump_{0}.png",
  TTMGroupManualStation: "/images/map/marker_well_{0}.png",
  TTMEquipmentDispense: "/images/map/marker_well_{0}.png",
  TTMGroupPumpStation: "/images/map/marker_bps_{0}.png",
  TTMMobileStation: "/images/map/marker_bps_{0}.png",
  TTMSurfaceHole: "/images/map/marker_well_{0}.png",
  TTMEnergySubstation: "/images/map/marker_well_{0}.png",
  TTMWellCluster: "/images/map/marker_well_{0}.png",
  TTMBlockPumpStation: "/images/map/marker_bps_{0}.png",
  TTMStation: "/images/map/marker_well_{0}.png",
  TTMGMS: "/images/map/marker_gms_{0}.png",
  TTMGMSManual: "/images/map/marker_gms_{0}.png",
  TTMGMPumpStation: "/images/map/marker_gms_{0}.png",
};

export const GROUP_COLORS = {
  2: "yellow",
  1: "green",
  3: "green",
  4: "red",
  5: "orange",
  default: "green"
};
export const TILE_PROVIDERS = [
  {
    name: "Cyclosm OpenStreetMap",
    visible: true,
    attribution:
      '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a>',
    url: "https://{s}.tile-cyclosm.openstreetmap.fr/cyclosm//{z}/{x}/{y}.png",
  },
  {
    name: "GoogleMap",
    visible: false,
    url: "http://mt0.google.com/vt/lyrs=s&x={x}&y={y}&z={z}",
    attribution:
      '&copy; <a href="https://www.google.com/intl/ru_ru/help/legalnotices_maps/">GoogleMap</a>',
  },
  {
    name: "OpenTopoMap",
    visible: false,
    attribution:
      '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a>',
    url: "https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png",
  }
];
